var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2092_9111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2092_9111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3083 67.9248L72.175 41.0581L70.3333 39.2165L45.3083 64.3498L32.7417 51.7831L31.0083 53.6248L45.3083 67.9248ZM51.7 89.6998C46.5 89.6998 41.625 88.7067 37.075 86.7206C32.525 84.7345 28.5347 82.0262 25.1042 78.5956C21.6736 75.1651 18.9653 71.1748 16.9792 66.6248C14.9931 62.0748 14 57.1998 14 51.9998C14 46.7998 14.9931 41.9067 16.9792 37.3206C18.9653 32.7345 21.6736 28.7442 25.1042 25.3498C28.5347 21.9554 32.525 19.2651 37.075 17.279C41.625 15.2929 46.5 14.2998 51.7 14.2998C56.9 14.2998 61.793 15.2929 66.3792 17.279C70.9653 19.2651 74.9555 21.9554 78.35 25.3498C81.7444 28.7442 84.4347 32.7345 86.4208 37.3206C88.4069 41.9067 89.4 46.7998 89.4 51.9998C89.4 57.1998 88.4069 62.0748 86.4208 66.6248C84.4347 71.1748 81.7444 75.1651 78.35 78.5956C74.9555 82.0262 70.9653 84.7345 66.3792 86.7206C61.793 88.7067 56.9 89.6998 51.7 89.6998ZM51.7 87.3165C61.5222 87.3165 69.8639 83.8859 76.725 77.0248C83.5861 70.1637 87.0167 61.822 87.0167 51.9998C87.0167 42.1776 83.5861 33.8359 76.725 26.9748C69.8639 20.1137 61.5222 16.6831 51.7 16.6831C41.8778 16.6831 33.5361 20.1137 26.675 26.9748C19.8139 33.8359 16.3833 42.1776 16.3833 51.9998C16.3833 61.822 19.8139 70.1637 26.675 77.0248C33.5361 83.8859 41.8778 87.3165 51.7 87.3165Z",
    fill: "url(#paint0_linear_2092_9111)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2092_9111",
    x1: 85.3126,
    y1: 14.1481,
    x2: 17.9571,
    y2: 89.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#ED76AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSuccess);
export default __webpack_public_path__ + "static/media/feedback-success.da4585ce5b5787c923e2b1b0839ef022.svg";
export { ForwardRef as ReactComponent };